module.exports = __webpack_public_path__ + "img/7_Hepatic--Flexure.1bc7c217.png";